
import Box2 from "../../../assets/outline/Box2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Box2Icon({ className, dataTestid = "Box2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Box2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
